import { useMutation } from 'react-query'

import { APIError } from '../../../utils'
import { exportBackup } from '../services/query-api'

interface UseExportBackupProps {
  onError?: (error?: APIError) => void
  onSettled?: (data: void, error: APIError | null | undefined) => void
  onSuccess?: (data: unknown) => void
}

export const useExportBackup = (props?: UseExportBackupProps) => {
  const { onError, onSuccess } = props || {}
  const { mutate, isLoading, ...rest } = useMutation(exportBackup, { onSuccess, onError })

  return { mutate, isLoading, ...rest }
}
